<div id="media" [ngSwitch]=getType() class="d-flex justify-content-center">

  <!-- Image -->
  <div class="image" *ngSwitchCase="'image'">
    <img  id="image" [(src)]="resourceFile" alt="">
    <div id="media-text" class="text" *ngIf='!!texts'>
      <!--<div *ngFor='let text of texts, let first = first' [ngClass]="{'heading': first, 'content': !first}">-->
      <div *ngFor='let text of texts, let first = first' class="heading">
        {{ text }}
      </div>
    </div>
  </div>
  <!-- End Image -->

  <!-- Video -->
  <vg-player id="video" *ngSwitchCase="'video'" (onPlayerReady)="onPlayerReady($event)">
    <vg-overlay-play *ngIf="!!replay" vgFor="singleVideo"></vg-overlay-play>
    <vg-controls *ngIf="!!replay" vgFor="singleVideo">
      <vg-play-pause></vg-play-pause>
      <vg-time-display [vgProperty]="'current'" [vgFormat]="'mm:ss'"></vg-time-display>
      <vg-scrub-bar>
        <vg-scrub-bar-current-time  [vgSlider]="true"></vg-scrub-bar-current-time>
        <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
      </vg-scrub-bar>
      <vg-time-display [vgProperty]="'total'" [vgFormat]="'mm:ss'"></vg-time-display>
      <vg-mute class='hide-control'></vg-mute>
      <vg-volume class='hide-control'></vg-volume>
      <vg-track-selector></vg-track-selector>
      <vg-fullscreen class='hide-control'></vg-fullscreen>
    </vg-controls>
    <video [vgMedia]="media" #media id="singleVideo" preload="auto" playsinline autoplay>
      <source [src]="resourceFile" type="video/mp4">
      <track *ngIf="!!subtitleFile" kind="subtitles" i18n-label label="English" [src]="subtitleFile" i18n-srclang srclang="en">
    </video>
  </vg-player>
  <!-- End Video -->

</div>
